var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.791667 12.6668C0.791667 13.0867 0.958482 13.4894 1.25541 13.7864C1.55235 14.0833 1.95507 14.2501 2.375 14.2501H8.70833C9.12826 14.2501 9.53099 14.0833 9.82792 13.7864C10.1249 13.4894 10.2917 13.0867 10.2917 12.6668V3.16679H0.791667V12.6668ZM2.375 4.75012H8.70833V12.6668H2.375V4.75012ZM8.3125 0.791789L7.52083 0.00012207H3.5625L2.77083 0.791789H0V2.37512H11.0833V0.791789H8.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHoliday);
export default __webpack_public_path__ + "static/media/delete-holiday.9509c0b4.svg";
export { ForwardRef as ReactComponent };